import React from "react";
import styles from "./MarketClosedOverlay.module.css";

export const MarketClosedOverlay: React.FC = () => (
  <div className={styles.overlay}>
    <span className={styles.label}>Asset closed</span>
  </div>
);
